// eslint-disable-next-line import/prefer-default-export
export const OPENACCOUNTSSTEPS = Object.freeze({
  ACCOUNTSELECT: 'account-select',
  GOALSELECT: 'goal-select',
  RISKTOLERANCE: 'risk-tolerance',
  ASSETALLOCATION: 'asset-allocation',
  GETSTARTED: 'get-started',
  OPENACCOUNT: 'open-account',
});

export const catAccountHolderTypes = [
  {
    enumValue: 'INDIVIDUAL_CUSTOMER',
    customerType: 'Individual Customer',
    description:
      'An account that does not meet the definition of FINRA Rule 4512(c) and is also not a proprietary account.',
    defaultIfFaiAffiliationIsNotSet: true,
  },
  {
    enumValue: 'EMPLOYEE_ACCOUNT',
    customerType: 'Employee  Account',
    description:
      'An employee or associated person of any company associated with the financial services industry (see FINRA rule 4512(c) for more information).',
    defaultIfFaiAffiliationIsNotSet: false,
  },
  {
    enumValue: 'INSTITUTIONAL_CUSTOMER',
    customerType: 'Institutional Customer',
    description:
      'A large company or organization who invests substantial capital on behalf of clients or members (see FINRA rule 4512(c) for more information).',
    defaultIfFaiAffiliationIsNotSet: false,
  },
];

export const ACCOUNT_TYPE_ID = Object.freeze({
  ROTH: 1,
  TRADITIONAL: 2,
  INDIVIDUAL: 3,
  SEP: 13,
  SIMPLE: 14,
});
